import styled from 'styled-components'
import { Avatar } from 'antd'
import { font } from 'assets/themes/theme-default'

const AntAvatarStyled = styled(Avatar)`
  &&& {
    border-width: 2px;
    border-style: solid;
    border-color: ${props => props.theme.colors.color1.bg};
    font-weight: ${font.weight.bold};
    width: 36px;
    height: 36px;
    cursor: context-menu;
  }
`
export default AntAvatarStyled
